<!--
  - Copyright (c) 2024 brightlamp
  -->

<template>
    <div>
        Telehealth Redirect
    </div>
</template>

<script>
    import {mapActions} from 'vuex';

    export default {
        async mounted()
        {
            const queryParams = this.$route.query;
            // Deep link URL
            const paramValue = queryParams.testToken;
            await this.SEND_DEEP_LINK_URL(paramValue);

            this.openAppOrFallback()
        },
        methods:
        {
            ...mapActions('telehealth', ['SEND_DEEP_LINK_URL']),
            openAppOrFallback()
            {
                window.location = "https://apps.apple.com/us/app/reflex-telehealth/id1553943787";
            }
        }
    }
</script>